import React from 'react';

import { EmptyPageState, MainPage } from '../../components';

export const SettingsScreen = () => {
  const isDialogOpen = false;

  const handleOpenDialog = () => {}

  const isShouldShowEmptyState = true;

  return (
    <MainPage
      title="Settings"
      isDialogOpen={isDialogOpen}
      isShouldShowEmptyState={isShouldShowEmptyState}
      onAddButtonClick={handleOpenDialog}
      DialogComp={<></>}
      DrawerComp={<></>}
      EmptyStateComp={<EmptyPageState
        image="/images/empty-page-states/analytics.png"
        title="Currently, there is no settings page available for display"
        subTitle="Access to the Settings timable depending to configure. To unlock the power of settings, start by settings your staff to do some settings configurations."
      />}
    >
      <main className="main-page">
        here should be settings screen
      </main>
    </MainPage>
  );
}
